'use client';

import getService from '@/actions/services/getService';
import StudioPreview from '@/assets/svg/StudioPreview';
import { AspectRatio } from '@/components/ui/aspect-ratio';
import { cn } from '@/lib/utils';
import { motion } from 'framer-motion';
import Image from 'next/image';
import { useEffect, useState } from 'react';

export default function Preview({ img }: { img: any }) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 640);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);
  return (
    <div className='w-screen overflow-hidden relative '>
      <motion.div className='w-full h-full'>
        <motion.div
          animate={{ x: 0, y: 0 }}
          transition={{ type: 'tween', ease: 'backOut', duration: 0.5 }}
          className='w-full h-full'
        >
          {!isMobile ? (
            <Image
              src={img}
              className='w-full h-full object-cover'
              alt=''
              unoptimized
              onContextMenu={(e) => e.preventDefault()}
            />
          ) : (
            <div
              className='relative w-full'
              style={{ paddingBottom: `${(img.height / img.width) * 100}%` }}
            >
              <Image
                src={img}
                alt=''
                fill
                className='object-contain'
                unoptimized
                onContextMenu={(e) => e.preventDefault()}
              />
            </div>
          )}
        </motion.div>
      </motion.div>
    </div>
  );
}